var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"netBudget"},[_vm._v("\n  (NET)\n  "),_c('AppCurrency',{attrs:{"value":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }